var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"balance-layer"},[(_vm.balance)?_c('div',{staticClass:"row"},[_vm._v(" "+_vm._s(_vm.balanceFormat(_vm.balance))+" "),_c('span',[_vm._v(_vm._s(_vm.currency))])]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }